import AppManagerClient from '../../api/AppManagerClient';
import { IManagingScheduledTasksInstance } from '../../api/models';
import React, { useEffect } from 'react';
import { ScheduledTasksInfoView } from './ScheduledTasksInfoView';
import { Merger } from '../../helpers/Merger';

export const ScheduledTasksInfo = (props: any) => {
    const [serverApps, setServerApps]: [IManagingScheduledTasksInstance[], Function] = React.useState([]);
    const [isLoading, setLoadingStatus] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getScheduledTasksForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <ScheduledTasksInfoView
            serverApps={Merger.merge(serverApps)}
            isLoading={isLoading}
            errorMessage={errorMessage}
            isDataNotFound={serverApps.length === 0}
            applicationName={applicationName}
        />
    );
};
